import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';
import { Actions } from '../actions/intakeSent-actions';
import { IntakeSentActions } from '../constants';
import { IIntakeSent } from 'src/types/intake-sent';

export interface IntakeSentState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IIntakeSent>;
    current: IIntakeSent | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],

        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
};

export function intakeSents(state: IntakeSentState = initialState, action: Actions | any): IntakeSentState {
    switch (action.type) {
        case requestType(IntakeSentActions.PERSIST_INTAKE_SENT):
            return { ...state, error: '', inProgress: true };
        case successType(IntakeSentActions.PERSIST_INTAKE_SENT):
            return { ...state, current: action.payload, inProgress: false };
        case failureType(IntakeSentActions.PERSIST_INTAKE_SENT):
            return { ...state, error: action.error, inProgress: false };
        default:
            return state;
    }
}
